/* eslint-disable react/jsx-props-no-spreading, react/prop-types, react/destructuring-assignment */
import React, { useState, useEffect } from 'react';

const inputGuard = ({
  component: Component,
  valueProp,
  changeHandlerProps,
}) => {
  const InputGuard = props => {
    const valuePropValue = props[valueProp];

    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState(valuePropValue);

    useEffect(() => {
      if (focused) return;
      setValue(valuePropValue);
    }, [focused, valuePropValue]);

    const changeHandlers = changeHandlerProps.reduce(
      (acc, changeHandlerProp) => {
        acc[changeHandlerProp] = event => {
          setValue(event.target[valueProp]);
          const changeHandler = props[changeHandlerProp];
          if (typeof changeHandler === 'function') {
            changeHandler(event);
          }
        };

        return acc;
      },
      {},
    );

    const handleFocus = event => {
      setFocused(true);
      if (typeof props.onFocus === 'function') {
        props.onFocus(event);
      }
    };

    const handleBlur = event => {
      setFocused(false);
      if (typeof props.onBlur === 'function') {
        props.onBlur(event);
      }
    };

    return (
      <Component
        {...props}
        {...{ [valueProp]: value }}
        {...changeHandlers}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    );
  };

  // Will assign `propTypes`, `defaultProps`, and other properties from the original component.
  Object.assign(InputGuard, Component);

  return InputGuard;
};

export default inputGuard;
